import { Injectable } from "@angular/core";
import { DepositSurvey } from "../domain/entities/deposit-survey.model";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserService } from "@main-services/user.service";
import { Helper } from "@helpers/functions";
import { DEPOSIT_SURVEY_STATUS_KEY } from "@modules/+new/payments/features/deposit-survey/domain/const/constants";
import { DepositSurveyStatus } from "@modules/+new/payments/features/deposit-survey/domain/const/deposit-survey-status.enum";

@Injectable()
export class DepositSurveyService {
	private refreshDepositSurveyLink$ = new BehaviorSubject(null);

	public constructor(
		private readonly launchDarklyService: LaunchDarklyService,
		private readonly userService: UserService
	) {}

	public saveVisitingSurvey(): void {
		Helper.setCookie(DEPOSIT_SURVEY_STATUS_KEY, DepositSurveyStatus.VISITED);
		this.refreshDepositSurveyLink$.next(null);
	}

	public getDepositSurveyLink$(): Observable<string> {
		return combineLatest([
			this.launchDarklyService.getFeatureConfig$<DepositSurvey>(LD_FLAG.SURVEY_DEPOSIT),
			this.refreshDepositSurveyLink$
		]).pipe(map(([depositSurvey, _]) => this.prepareDepositSurveyLink(depositSurvey)));
	}

	private prepareDepositSurveyLink(depositSurvey: DepositSurvey): string {
		if (!this.userService.user.isVerified() || this.isSurveyAlreadyVisited()) {
			return null;
		}

		const currentShortLang = this.userService.user.getShortLang();

		const linkForCurrentLanguage = depositSurvey?.[currentShortLang];
		if (this.isValueTypeValid(linkForCurrentLanguage)) {
			return linkForCurrentLanguage;
		}

		const linkForDefaultLanguage = depositSurvey?.en;
		if (this.isValueTypeValid(linkForDefaultLanguage)) {
			return linkForDefaultLanguage;
		}

		return null;
	}

	// TODO: eslint fix
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private isValueTypeValid(value: any): boolean {
		return !!value && typeof value === "string";
	}

	private isSurveyAlreadyVisited(): boolean {
		const cachedStatus = Helper.getCookie(DEPOSIT_SURVEY_STATUS_KEY);
		return cachedStatus === DepositSurveyStatus.VISITED;
	}
}
